export var RemoteCatalogType;
(function (RemoteCatalogType) {
    RemoteCatalogType["REMOTE_CATALOG_TYPE_AWS_GLUE"] = "AWS_GLUE";
    RemoteCatalogType["REMOTE_CATALOG_TYPE_EON_BACKUP"] = "EON_BACKUP";
})(RemoteCatalogType || (RemoteCatalogType = {}));
